import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation, withRouter } from 'react-router-dom';
import { Menu } from 'antd';
import menu from '../menu';
// import MenuGroupItem from '../components/Menu/MenuGroupItem';
// import MenuItem from '../components/Menu/MenuItem';
import rolesApi from '../api/roles';
import userPermissionsApi from '../api/user-permissions';

function AppSidebar() {
  // const [collapsed, setCollapsed] = useState(false);
  const isMount = useRef(false);
  const [menuDisplay, setMenuDisplay] = useState([]);
  const authUser = useSelector((state) => state.auth.authUser);
  const history = useHistory();
  const location = useLocation();
  const { pathname } = location;

  useEffect(() => {
    isMount.current = true;
    const fetchMenuData = async () => {
      try {
        if (isMount) {
          setMenuDisplay(menu);
        }
      } catch (error) {
        console.error('Error fetching menu data:', error);
      }
    };
    fetchMenuData();

    return () => {
      isMount.current = false;
    };
  }, [authUser]);

  // const onCollapse = (collapsed) => {
  //   setCollapsed(collapsed);
  // };

  const onClickMenu = (key) => {
    history.push(key);
  };

  const filterMenu = (menuItems, items) => {
    return menuItems
      .map((menuItem) => {
        // console.log('menuItem: ', menuItem);
        const hasChildren = menuItem.children && menuItem.children.length > 0;
        let filteredChildren = null;

        if (hasChildren) {
          filteredChildren = filterMenu(menuItem.children, items);
        }

        const hasMatchingChild =
          filteredChildren && filteredChildren.length > 0;
        const hasMatchingItem = items.some(
          (item) => item.menuitem.path === menuItem.key
        );

        if (hasMatchingChild) {
          return { ...menuItem, children: filteredChildren };
        } else if (hasMatchingItem) {
          return menuItem;
        }

        return null;
      })
      .filter(Boolean);
  };

  // const renderMenuItems = (menuItems) => {
  //   return menuItems.map((menuItem) => {
  //     const hasChildren = menuItem.children && menuItem.children.length > 0;
  //     if (hasChildren) {
  //       return (
  //         <Menu.SubMenu key={menuItem.key} title={menuItem.label}>
  //           {renderMenuItems(menuItem.children)}
  //         </Menu.SubMenu>
  //       );
  //     } else {
  //       return (
  //         <Menu.Item key={menuItem.key} icon={menuItem.icon}>
  //           {menuItem.label}
  //         </Menu.Item>
  //       );
  //     }
  //   });
  // };

  return (
    <Menu
      theme="dark"
      mode="inline"
      selectedKeys={[pathname]}
      style={{ borderRight: 0 }}
      onClick={({ item, key, keyPath }) => onClickMenu(key)}
      items={menuDisplay}>
      {/* {menu.map((item, key) => {
        if (item.children) {
          return <MenuGroupItem item={item} key={key} />;
        } else {
          return <MenuItem item={item} key={item.path} />;
        }
      })} */}
    </Menu>
  );
}

export default withRouter(AppSidebar);
